/* eslint-disable no-unused-vars */
/**
 * Imports the necessary modules from the React library for a React component.
 * @module React
 * @module useState
 * @module useTranslation
 */
import React, { useRef, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useTranslation } from "react-i18next";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

/**
 * Imports the necessary components and utilities for the current module.
 * @import CustomButton from "../../components/customButton/customButton" - The custom button component.
 * @import ConfirmModal from "../../components/confirmModal/confirmModel" - The confirm modal component.
 * @import TextField from "../../components/TextField/TextField" - The text field component.
 * @import HookForm from "../../components/HookForm/HookForm" - The hook form component.
 * @import Constant from "../../util/constant" - The constant utility module.
 */
// import * as textEditor from "../../../api/textEditor.json";

import { Controller } from "react-hook-form";
import ConfirmModal from "../../../components/confirmModal/confirmModel";
import CustomButton from "../../../components/customButton/customButton";
import FileUpload from "../../../components/fileUpload/fileUpload";
import HookForm from "../../../components/hookForm/hookForm";
import TextField from "../../../components/textField/textField";
import { getCloudinaryMediaBaseUrl } from "../../../config/cloudinaryBase";
import { resolveCloudinaryImageSrc } from "../../../helpers/helper.service";
import Constant from "../../../util/constant";
import "./createArtist.css";

/**
 * Creates a component for displaying an artist.
 * @param {{object}} props - The props passed to the component.
 * @returns The JSX code for rendering the artist component.
 */
const CreateArtistComponent = (props) => {
  /**
   * Destructures the necessary properties from the props object.
   * @param {{object}} props - The props object containing the necessary properties.
   * @returns None
   */
  const {
    showCreateArtistModal,
    closeCreateArtistModal,
    modalName,
    createArtistModelLoaderButton,
    handleArtisttextChange,
    artisttextcount,
    clearCreatData,
    handleSubmitCreate,
    artistValue,
    artistprofileValue,
    setIsUploadingDocumentLink,
    triggerRef,
    isUploadingDocumentLink,
    aboutTextEditorValue,
    setAboutTextEditorValue,
    handleUploadThumnailFile,
    handleClearUploadedThumnailFile,
    profileImage,
    uploadedDocumentThumnailFile,
    aboutTouched,
    setAboutTouched,
    instagramUrlValue,
  } = props;

  const { t } = useTranslation();
  // const [rawData, setRawData] = useState();

  const [dimenstionError, setDimenstionError] = useState(false);
  const uploadThumNailValid = {
    "image/jpeg": [],
    "image/png": [],
    "image/jpg": [],
  };

  const reactQuillRefIns = useRef();

  // eslint-disable-next-line no-unused-vars
  const [aboutTextEditorValueCount, setAboutTextEditorValueCount] = useState();
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "color",
  ];
  /**
   * Handles the upload of a thumbnail file.
   * @param {{FileList}} files - The list of files to upload.
   * @returns None
   */
  // const handleUploadThumnailFile = (files) => {
  //   if (files && files?.length > 0) {

  //     setuploadedDocumentThumnailFile(files);
  //     const reader = new FileReader();
  //     reader.addEventListener("load", (event) => {
  //       setProfileImage(event?.target?.result);
  //     });
  //     reader.readAsDataURL(files[0]);
  //   } else {
  //     setuploadedDocumentThumnailFile(null);
  //     setProfileImage(null);
  //   }
  // };

  /**
   * Handles the upload of a thumbnail image file.
   * @param {{FileList}} files - The list of files to upload.
   * @param {{boolean}} loaderState - The state of the loader.
   * @param {{Function}} uploadFunction - The function to handle the upload of the files.
   * @returns None
   */
  const handleUploadThumnail = (files, loaderState, uploadFunction) => {
    loaderState = true;
    setTimeout(() => {
      uploadFunction(files);
      loaderState = false;
    }, 1000);
  };

  /**
   * An object representing the properties of an artist.
   * @property {{string}} thumbnailfile - The thumbnail file of the artist.
   * @property {{string}} aboutartist - Information about the artist.
   * @property {{string}} artistname - The name of the artist.
   * @returns None
   */
  const CreateArtist = {
    thumbnailfile: {
      name: "thumbnailfile",
      validate: {
        required: {
          value: false,
        },
      },
    },
    aboutartist: {
      name: "aboutartist",
      validate: {
        required: {
          value: true,
        },
      },
    },
    artistname: {
      name: "artistname",
      validate: {
        required: {
          value: true,
        },
        pattern: {
          value: Constant.REGEX.ALPHANUMERICSPECIALCHAR,
          message: t("ALLOWED_ONLY_ALPHABETS_NUMBERS_AND_SPECIALCHARACTERS"),
        },
        maxLength: {
          value: 70,
          message: t("ALLOWED_MAX_70_CHARACTERS"),
        },
      },
    },
    instagramurl: {
      name: "instagramurl",
      validate: {
        required: {
          value: false,
        },
        validate: (v) => {
          const s = (v || "").trim();
          if (!s) return true;
          if (s.startsWith("@")) return t("ARTIST_INSTAGRAM_URL_INVALID");
          if (!Constant.REGEX.HTTP_URL.test(s)) {
            return t("ARTIST_INSTAGRAM_URL_INVALID");
          }
          return true;
        },
      },
    },
  };

  const htmlString = aboutTextEditorValue;
  const parseHTML = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc?.body?.textContent || "";
  };
  const textContent = parseHTML(htmlString);

  const CLOUDINARY_URL = getCloudinaryMediaBaseUrl();
  return (
    <ConfirmModal
      className={"Deactivate import-model createArtist"}
      modalTitle={
        modalName.modal === "add" ? t("ADD_ARTIST") : t("EDIT_ARTIST")
      }
      showModal={showCreateArtistModal}
      isModelIcon={false}
      modalContent={false}
      isFirstButton={false}
      isSecondButton={false}
      onProcced={() => {}}
      closeModelIcon={() => {
        closeCreateArtistModal();
        // setAboutTouched(false);
        setDimenstionError(false);
      }}
      isCloseBtn={true}
    >
      {/**
       * Renders a form component with input fields for creating a artist.
       * @param {Object} defaultForm - The default form values.
       * @param {string} className - The CSS class name for the form.
       * @param {Function} init - The initialization function for the form.
       * @returns The rendered form component.
       */}
      <HookForm
        defaultForm={{
          artistname: modalName.modal === "add" ? "" : artistValue,
          aboutartist: modalName.modal === "add" ? "" : aboutTextEditorValue,
          thumbnailfile: modalName.modal === "add" ? "" : artistprofileValue,
          instagramurl:
            modalName.modal === "add" ? "" : instagramUrlValue || "",
        }}
        className="form-horizontal"
        init={(form) => {}}
        onSubmit={(e) => {
          handleSubmitCreate(e);
        }}
      >
        {(formMethod) => {
          console.log(
            "createArtistModelLoaderButton-------------",
            createArtistModelLoaderButton
          );
          return (
            <>
              <div className="uploadWrapper createPageWrapper">
                <div className="textFiledWrapper wrapper-input imgUpload create-artist-img-upload">
                  <Controller
                    formMethod={formMethod}
                    errors={formMethod?.formState.errors}
                    name={CreateArtist.thumbnailfile.name}
                    rules={CreateArtist.thumbnailfile.validate}
                    control={formMethod.control}
                    render={({ field: { onChange, value } }) => (
                      <div className="fileWrapper create-artist-file-wrapper">
                        <FileUpload
                            onDrop={async (acceptedFiles) => {
                              const validFileTypes =
                                Object.keys(uploadThumNailValid);
                              const validFiles = acceptedFiles.filter((file) =>
                                validFileTypes.includes(file.type)
                              );

                              // Custom validation for image dimensions (512x512)
                              const isValidDimensions = await Promise.all(
                                acceptedFiles.map(async (file) => {
                                  const img = new Image();
                                  img.src = URL.createObjectURL(file);

                                  return new Promise((resolve) => {
                                    img.onload = function () {
                                      const width = img.width;
                                      const height = img.height;
                                      if (width / height === 4 / 3) {
                                        resolve(true);
                                      } else {
                                        resolve(false);
                                      }
                                    };
                                  });
                                })
                              );
                              if (
                                validFiles.length > 0
                                // &&
                                // isValidDimensions.every((isValid) => isValid)
                              ) {
                                handleUploadThumnail(
                                  validFiles,
                                  setIsUploadingDocumentLink,
                                  handleUploadThumnailFile
                                );
                                setDimenstionError(false);
                              } else {
                                handleUploadThumnail(
                                  validFiles,
                                  setIsUploadingDocumentLink,
                                  handleUploadThumnailFile
                                );
                                // Handle validation error here
                                setDimenstionError(true);
                              }
                              onChange(acceptedFiles);
                            }}
                            maxSize={10 * 1024 * 1024} // 10 MB
                            accept={uploadThumNailValid}
                            triggerOpen={triggerRef}
                          >
                            <>
                              {isUploadingDocumentLink ? (
                                <>
                                  <div className="progressWrapper">
                                    <div className="progress">
                                      <div className="progressValue"></div>
                                    </div>
                                    <p>{t("UPLOADINGONLY")}</p>
                                  </div>
                                </>
                              ) : (
                                <div className="dropZoneWrapper create-artist-dropzone">
                                  <div className="create-artist-preview">
                                    {uploadedDocumentThumnailFile ? (
                                      <img
                                        src={profileImage}
                                        alt={t("UPLOAD_IMAGE")}
                                      />
                                    ) : modalName.modal === "add" ? (
                                      <i
                                        className="bx bxs-image create-artist-preview-icon"
                                        aria-hidden="true"
                                      />
                                    ) : (
                                      <img
                                        src={resolveCloudinaryImageSrc(
                                          artistprofileValue,
                                          CLOUDINARY_URL,
                                          "dummy-profile.png"
                                        )}
                                        alt={t("UPLOAD_IMAGE")}
                                      />
                                    )}
                                  </div>
                                  <span
                                    className="create-artist-camera-badge"
                                    aria-hidden="true"
                                  >
                                    <i className="bx bxs-camera" />
                                  </span>
                                </div>
                              )}
                            </>
                          </FileUpload>
                        {dimenstionError ? (
                          <p className="errorMsg create-artist-upload-error">
                            {t("THE_IMAGE_RATIO_SHOULD_BE_4_3")}
                          </p>
                        ) : null}
                      </div>
                    )}
                  />
                  <p className="msg create-artist-upload-hint">
                    {t("THE_IMAGE_RATIO_SHOULD_BE_4_3")}
                  </p>
                </div>
                <div className="d-flex">
                  <p className="form-label">{t("ARTIST_NAME")}</p>
                  <p className="requiredStyle">*</p>
                </div>
                <div className="textFiledWrapper wrapper-input">
                  <TextField
                    formMethod={formMethod}
                    rules={CreateArtist.artistname.validate}
                    name={CreateArtist.artistname.name}
                    errors={formMethod?.formState.errors}
                    autoFocus={true}
                    textCountVisible={true}
                    textcount={artisttextcount}
                    textCountTotal={70}
                    maxLength="70"
                    required={false}
                    type="text"
                    placeholder={t("ENTER_ARTIST_NAME")}
                    onChange={handleArtisttextChange}
                  />

                  {formMethod.getValues("artistname") !== "" ? (
                    <button
                      onClick={() => {
                        clearCreatData();
                      }}
                      className="clearInput btn-close"
                      aria-label="Close"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="d-flex">
                  <p className="form-label">{t("ARTIST_INSTAGRAM_URL")}</p>
                </div>
                <div className="textFiledWrapper wrapper-input">
                  <TextField
                    formMethod={formMethod}
                    rules={CreateArtist.instagramurl.validate}
                    name={CreateArtist.instagramurl.name}
                    errors={formMethod?.formState.errors}
                    required={false}
                    type="text"
                    placeholder={t("ARTIST_INSTAGRAM_URL_PH")}
                  />
                </div>
                <div className="d-flex">
                  <p className="form-label">{t("ABOUT_ARTIST")}</p>
                  <p className="requiredStyle">*</p>
                </div>
                <div className="customQuillEditoAbout">
                  <Controller
                    formMethod={formMethod}
                    name={CreateArtist.aboutartist.name}
                    control={formMethod.control}
                    render={({ field: { onChange, value } }) => (
                      <ReactQuill
                        placeholder="Enter description"
                        value={aboutTextEditorValue}
                        ref={reactQuillRefIns}
                        formats={formats}
                        modules={{
                          toolbar: [
                            ["bold", "italic", "underline"],
                            [{ list: "ordered" }],
                          ],
                        }}
                        onChange={(content, delta, source, editor, e) => {
                          const textContentone = editor.getText(content);
                          setAboutTextEditorValue(content);
                          setAboutTouched(true);
                          onChange(content);
                          setAboutTextEditorValueCount(textContentone?.length);
                          const quill = reactQuillRefIns?.current?.getEditor();
                          quill?.on(
                            "text-change",
                            function (delta, old, source) {
                              if (quill?.getLength() > 499) {
                                quill?.deleteText(500, quill?.getLength());
                              }
                            }
                          );
                        }}
                      />
                    )}
                  />
                  <div className="customQuillEditorCount">
                    {/* {aboutTextEditorValueCount > 2501 ? <span className='errorMsg'>MaxLength 2500 Character Only</span> : null} */}
                    {!textContent && aboutTouched ? (
                      <span className="errorMsg">
                        {" "}
                        <span>{t("THIS_FIELD_IS_REQUIRED")}</span>
                      </span>
                    ) : (
                      <span className="errorMsg"></span>
                    )}
                    <span className="badgecount badge">
                      {textContent?.length > 0 ? textContent?.length : 0}
                      /500
                    </span>
                  </div>
                </div>
              </div>
              <div className="Form_buton">
                <CustomButton
                  className="black-btn fillButton"
                  disabled={
                    modalName.modal === "add"
                      ? !formMethod.formState.isValid ||
                        !textContent ||
                        dimenstionError === true
                      : !formMethod.formState.isValid ||
                        !formMethod.formState.isDirty ||
                        !textContent ||
                        dimenstionError === true
                  }
                  loading={createArtistModelLoaderButton}
                  type="submit"
                >
                  {modalName.modal === "add" ? t("ADD_ARTIST") : t("UPDATE")}
                </CustomButton>
                <CustomButton
                  className="black-btn borderButton"
                  onClick={() => {
                    setAboutTouched(false);
                    setDimenstionError(false);
                    closeCreateArtistModal(true);
                  }}
                  type="button"
                >
                  {t("CANCEL")}
                </CustomButton>
              </div>
            </>
          );
        }}
      </HookForm>
    </ConfirmModal>
  );
};

export default CreateArtistComponent;
